import React, { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { toast } from "sonner";

export default function ImageUpload({ value, onChange, label = "Imagem" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Imagem enviada!");
    } catch {
      toast.error("Falha ao enviar imagem.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <div className="text-sm font-medium mb-1">{label}</div>
      <div className="flex items-center gap-3">
        <div className="w-20 h-20 rounded-lg overflow-hidden bg-[var(--bg-secondary)] border border-[var(--border)] flex items-center justify-center shrink-0">
          {value ? <img src={fileUrl(value)} alt="" className="w-full h-full object-cover" /> : <span className="text-xs text-[var(--text-muted)]">Vazio</span>}
        </div>
        <input ref={ref} type="file" accept="image/*" hidden onChange={pick} />
        <button type="button" onClick={() => ref.current.click()} disabled={busy}
          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-[var(--border)] text-sm hover:border-[var(--accent)]">
          {busy ? <Loader2 className="animate-spin" size={16} /> : <Upload size={16} />} Enviar
        </button>
        {value && (
          <button type="button" onClick={() => onChange("")} className="text-[var(--text-muted)] hover:text-red-400"><X size={16} /></button>
        )}
      </div>
    </div>
  );
}
